import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IAgentUserPasswordClient,
    IPostInput,
    IPostOutput,
} from 'interfaceAdapter/gatewaySchemas/IAgentUserPasswordClient';
import { getCookie } from 'utils/cookie';
const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/user/reset_password`;

export class AgentUserPasswordClient implements IAgentUserPasswordClient {
    async post(input: IPostInput): Promise<IPostOutput> {
        const { code, password } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ code, password });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
